/* src/components/landing/LpNavbar.jsx */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { NAV_LINKS } from '../../data/landing';

export default function LpNavbar({ scrollTo }) {
  const [scrolled, setScrolled]     = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const active = scrolled || mobileMenu;

  const btnBase    = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, borderRadius: 'var(--radius-sm)', fontFamily: 'inherit', fontSize: '0.9rem', fontWeight: 600, textDecoration: 'none', border: 'none', cursor: 'pointer' };
  const btnPrimary = { ...btnBase, padding: '10px 20px', background: 'var(--accent)', color: 'var(--primary)' };
  const btnOutline = { ...btnBase, padding: '10px 20px', background: 'transparent', color: 'var(--primary)', border: '1.5px solid var(--border)' };

  const navLinkStyle  = { textDecoration: 'none', color: 'var(--text-muted)', fontSize: '0.9rem',  fontWeight: 500 };
  const mobLinkStyle  = { textDecoration: 'none', color: 'var(--text)',       fontSize: '0.95rem', fontWeight: 500, padding: '12px 0', borderBottom: '1px solid var(--border)' };

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
      padding: scrolled ? '12px 0' : '16px 0',
      background:    active ? 'rgba(255,255,255,0.95)' : 'transparent',
      backdropFilter: active ? 'blur(20px)' : 'none',
      borderBottom:  active ? '1px solid var(--border)' : 'none',
      transition: 'all 0.4s',
    }}>
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', fontWeight: 700, fontSize: '1.3rem', color: 'var(--primary)' }}>
          <div style={{ width: 36, height: 36, background: 'var(--primary)', borderRadius: 6, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--accent)', fontWeight: 700, fontSize: '1.1rem' }}>S</div>
          SimulaBank
        </Link>

        {/* Desktop nav */}
        <div className="desk-nav" style={{ display: 'flex', alignItems: 'center', gap: 32 }}>
          {NAV_LINKS.map(({ id, label }) =>
            id.startsWith('/')
              ? <Link key={id} to={id} style={navLinkStyle}>{label}</Link>
              : <a key={id} href={`#${id}`} onClick={scrollTo(id)} style={navLinkStyle}>{label}</a>
          )}
        </div>

        {/* Desktop buttons */}
        <div className="desk-btns" style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
          <Link to="/login"    style={btnOutline}>Entrar</Link>
          <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`}  target="_blank" rel="noopener noreferrer" style={btnPrimary}>Começar grátis</Link>
        </div>

        {/* Hamburger */}
        <button className="mob-toggle" onClick={() => setMobileMenu(!mobileMenu)} style={{ display: 'none', flexDirection: 'column', gap: 4.5, background: 'none', border: 'none', cursor: 'pointer', padding: 8, zIndex: 1001 }}>
          <span style={{ display: 'block', width: 22, height: 2, borderRadius: 1, background: 'var(--primary)', transition: 'all 0.3s', transform: mobileMenu ? 'rotate(45deg) translate(4.5px,4.5px)' : 'none' }} />
          <span style={{ display: 'block', width: 22, height: 2, borderRadius: 1, background: 'var(--primary)', transition: 'all 0.3s', opacity: mobileMenu ? 0 : 1 }} />
          <span style={{ display: 'block', width: 22, height: 2, borderRadius: 1, background: 'var(--primary)', transition: 'all 0.3s', transform: mobileMenu ? 'rotate(-45deg) translate(4.5px,-4.5px)' : 'none' }} />
        </button>
      </div>

      {/* Mobile menu */}
      {mobileMenu && (
        <div className="mob-menu" style={{ display: 'flex', flexDirection: 'column', padding: '12px 24px 20px', background: 'rgba(255,255,255,0.98)', borderTop: '1px solid var(--border)' }}>
          {NAV_LINKS.map(({ id, label }) =>
            id.startsWith('/')
              ? <Link key={id} to={id} onClick={() => setMobileMenu(false)} style={mobLinkStyle}>{label}</Link>
              : <a key={id} href={`#${id}`} onClick={scrollTo(id)} style={mobLinkStyle}>{label}</a>
          )}
          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <Link to="/login"    onClick={() => setMobileMenu(false)} style={{ ...btnOutline, flex: 1, justifyContent: 'center' }}>Entrar</Link>
            <Link to={`https://wa.me/5561991826667?text=${encodeURIComponent('Começar grátis')}`}  target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenu(false)} style={{ ...btnPrimary, flex: 1, justifyContent: 'center' }}>Começar grátis</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
